export enum action { FORGOT_PASSWORD = 2, VERIFY_VC = 5 }

export const minPasswordLength = 6;